/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionSet
 */
export interface PermissionSet {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionSet
     */
    read?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionSet
     */
    create?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionSet
     */
    update?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionSet
     */
    remove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionSet
     */
    delegate?: boolean;
}

/**
 * Check if a given object implements the PermissionSet interface.
 */
export function instanceOfPermissionSet(value: object): value is PermissionSet {
    return true;
}

export function PermissionSetFromJSON(json: any): PermissionSet {
    return PermissionSetFromJSONTyped(json, false);
}

export function PermissionSetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSet {
    if (json == null) {
        return json;
    }
    return {
        
        'read': json['read'] == null ? undefined : json['read'],
        'create': json['create'] == null ? undefined : json['create'],
        'update': json['update'] == null ? undefined : json['update'],
        'remove': json['remove'] == null ? undefined : json['remove'],
        'delegate': json['delegate'] == null ? undefined : json['delegate'],
    };
}

export function PermissionSetToJSON(json: any): PermissionSet {
    return PermissionSetToJSONTyped(json, false);
}

export function PermissionSetToJSONTyped(value?: PermissionSet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'read': value['read'],
        'create': value['create'],
        'update': value['update'],
        'remove': value['remove'],
        'delegate': value['delegate'],
    };
}

